import axios from 'axios';
import config from '../config/api.conf'
import router from '../router/router'

const api = axios.create(config);

api.interceptors.response.use((response) => {
    return response;
}, (error) => {
    let path = '/error';
    switch (error.response.status) {
        case 503: path = '/503'; break;
        case 404: path = '/404'; break;
    }
    router.push(path);
    return Promise.reject(error)
});

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js